// Ülke ve dil seçici (footer): seçim değişince form gönderilir, Güncelle düğmesi yalnız JS yokken görünür
document.querySelectorAll("[data-wd-locale]").forEach((form) => {
  form.classList.add("is-auto");
  form.querySelectorAll("select").forEach((s) => s.addEventListener("change", () => form.submit()));
});
